import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Divider, List, ListItem } from '@mui/material';

function CoExAccordian() {

    return(
        
    <div>
      <Accordion sx={{border: 3, borderColor: 'primary.main'}}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography variant="h5" sx={{color: 'primary.blackC'}}>
            <b> Center Of Excellence (CoE) </b></Typography>

        </AccordionSummary>
        <AccordionDetails>
            <Divider></Divider>
          <Typography variant="h6" sx={{color: 'primary.blackC'}}>
            
            <p>PMA extends its activities thru its various CoEs groups/sub-committees. The main objective of this is to provide platform to maximum number of active members. They work independently under PMA EC. PMA invites your participation in various committees mentioned below. Our endeavour would be to encourage participation of as many members as possible. PMA always been trying to establish better standards of management though such a social efforts. Both individual and institutional members  can participate in these sub-committees. Experts from various fields can form their own sub-Committees. Even Faculty Members or Students from the Institutes can form their own separate Committees.
              </p>
              <List>
               <ListItem sx={{ml:5,listStyleType: "disc", display: "list-item"}}><b>CoEs Civic Affairs & Sustainability </b>- Mr. Ajit Shinde (Civic Affairs) & Mr. Bhagyesh Abhyankar (Sustainability)</ListItem>
               <ListItem sx={{ml:5,listStyleType: "disc", display: "list-item"}}><b>CoE Entrepreneurship Development , Startup, MSME</b> - Mr. Sanjay Kulkarni</ListItem>
               
               <ListItem sx={{ml:5,listStyleType: "disc", display: "list-item"}}><b>Corporate Relations, Industry Academic Collaboration</b> - Mr. Rahul Joshi</ListItem>
               

               <ListItem sx={{ml:5,listStyleType: "disc", display: "list-item"}}><b>CoE Academics</b> -Prof. Abhijit Khurpe / NEP - Dr. Omkar Dange</ListItem>
               <ListItem sx={{ml:5,listStyleType: "disc", display: "list-item"}}><b>CoE - Business Excellence & Quality Management, IET,  Maha Engineers</b> - Mr. Sunjjoy Gupta / IET - Mr. Sachin Nimbalkar</ListItem>
               <ListItem sx={{ml:5,listStyleType: "disc", display: "list-item"}}><b>CoE -  Skill Development & Career Guidance, Young Manager </b>Mr. Dharmendra Patil </ListItem>
               
               <ListItem sx={{ml:5,listStyleType: "disc", display: "list-item"}}><b>CoE Human Resources</b> - Mr. Avinash Arvikar</ListItem>
               
               <ListItem sx={{ml:5,listStyleType: "disc", display: "list-item"}}><b>CoE - Media & Entertainment,  Publications</b> - Ms. Vidula Tokekar /  Publication - Janet Anthony</ListItem>
               
               
               <ListItem sx={{ml:5,listStyleType: "disc", display: "list-item"}}><b>CoE Sales and Marketing</b> - Mr. Rahul Joshi, make team</ListItem>
               
               
               <ListItem sx={{ml:5,listStyleType: "disc", display: "list-item"}}><b>MahaTrainers</b> - Dr. Smita Sovani</ListItem>
               <ListItem sx={{ml:5,listStyleType: "disc", display: "list-item"}}><b>CoE Finance</b></ListItem>
               
               
               
            </List>   
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  
    );
}
export default CoExAccordian;